import {
    filterOnlyMatchingNumberOfOuts, filterOnlyMatchingNumberOfBalls, filterOnlyMatchingNumberOfStrikes,
    filterOnlyMatchingRunnersOn, filterOnlyMatchingPitchResult, filterOnlyMatchingPitchType,
    filterOnlyMatchingStrikeZoneSectors, filterOnlyMatchingBatterHandedness, filterOnlyMatchingPitcherHandedness,
    filterOnlyMatchingPitchSet, filterOnlyMatchingBatterTagId, filterOnlyMatchingTagId
} from './byParameterValue.js';

const buildPitchScoringFilters = function({
    outs, balls, strikes, runnersOn,
}) {
    outs = outs || [];
    balls = balls || [];
    strikes = strikes || [];
    runnersOn = runnersOn || [];

    let scoringFilters = [];

    if (outs && outs.length) {
        scoringFilters = scoringFilters.concat(filterOnlyMatchingNumberOfOuts(outs));
    }
    if (balls && balls.length) {
        scoringFilters = scoringFilters.concat(filterOnlyMatchingNumberOfBalls(balls));
    }
    if (strikes && strikes.length) {
        scoringFilters = scoringFilters.concat(filterOnlyMatchingNumberOfStrikes(strikes));
    }
    if (runnersOn && runnersOn.length) {
        scoringFilters = scoringFilters.concat(filterOnlyMatchingRunnersOn(runnersOn));
    }

    return scoringFilters;
};

const buildPitchTaggingFilters = function({
    pitchResults, pitchTypes, pitchSet, zones, pitcherHandedness, batterHandedness
}) {
    pitchResults = pitchResults || [];
    pitchTypes = pitchTypes || [];
    zones = zones || [];
    pitchSet = pitchSet || '';
    pitcherHandedness = pitcherHandedness || '';
    batterHandedness = batterHandedness || '';

    let taggingFilters = [];

    if (pitchResults && pitchResults.length) {
        taggingFilters = taggingFilters.concat(filterOnlyMatchingPitchResult(pitchResults));
    }
    if (pitchTypes && pitchTypes.length) {
        taggingFilters = taggingFilters.concat(filterOnlyMatchingPitchType(pitchTypes));
    }
    if (zones && zones.length) {
        taggingFilters = taggingFilters.concat(filterOnlyMatchingStrikeZoneSectors(zones));
    }
    if (pitcherHandedness) {
        taggingFilters = taggingFilters.concat(filterOnlyMatchingPitcherHandedness(pitcherHandedness));
    }
    if (batterHandedness) {
        taggingFilters = taggingFilters.concat(filterOnlyMatchingBatterHandedness(batterHandedness));
    }
    if (pitchSet) {
        taggingFilters = taggingFilters.concat(filterOnlyMatchingPitchSet(pitchSet));
    }

    return taggingFilters;
};

const buildPitchPlayerFilters = function(pitcherIds, batterIds) {
    pitcherIds = pitcherIds || [];
    batterIds = batterIds || [];

    let playerFilters = [];

    if (pitcherIds && pitcherIds.length) {
        playerFilters = playerFilters.concat(filterOnlyMatchingTagId(pitcherIds));
    }
    if (batterIds && batterIds.length) {
        playerFilters = playerFilters.concat(filterOnlyMatchingBatterTagId(batterIds));
    }

    return playerFilters;
};

const buildHitPlayerFilters = function(batterIds) {
    batterIds = batterIds || [];

    let playerFilters = [];

    if (batterIds && batterIds.length) {
        playerFilters = playerFilters.concat(filterOnlyMatchingTagId(batterIds));
    }

    return playerFilters;
};

export {
    buildPitchScoringFilters, buildPitchTaggingFilters,
    buildPitchPlayerFilters, buildHitPlayerFilters,
};